export default __webpack_public_path__ + "static/media/undraw_upload_re_pasx.2418ca47.svg";